import { tokens } from '@fluentui/react-components';
import { Search24Regular } from '@fluentui/react-icons';

interface EmptyStateProps {
  message: string;
  variant?: 'page' | 'inline';
}

/**
 * EmptyState Component
 * Displays a message when no data is available
 *
 * Variants:
 * - page: Full empty state with padding and background (default)
 * - inline: Compact empty state for use in tables/modals
 */
export const EmptyState = ({ message, variant = 'page' }: EmptyStateProps) => {
  const isInline = variant === 'inline';

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '12px',
        padding: isInline ? '16px' : '48px 24px',
        minHeight: isInline ? 'auto' : '200px',
        color: isInline ? tokens.colorNeutralForeground3 : tokens.colorNeutralForeground4,
        fontSize: isInline ? tokens.fontSizeBase300 : tokens.fontSizeBase400,
        fontWeight: tokens.fontWeightRegular,
        textAlign: 'center',
      }}
    >
      {!isInline && <Search24Regular style={{ opacity: 0.5, fontSize: '32px' }} />}
      {message}
    </div>
  );
};

export default EmptyState;
